// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"7a1b76cda4ffeaf5ceb3","678":"a7cedd321b417fd7e3cf"}[chunkId] + ".js";
};